export default __webpack_public_path__ + "static/poster-4fd1d57b64682087a9cdc95a3398a988.png";